export const walletStatuses = [
  { id: 'live', label: 'live' },
  { id: 'inactive', label: 'inactive' },
];
